import { useEffect, useState } from "react";
import { Control, FieldValues, Path, useWatch } from "react-hook-form";
import { validatePassportIssueDate } from "./utils/validatePassport";

export const useValidatePassport = <T extends FieldValues>(control: Control<T>) => {
  const [issueDateWarn, setIssueDateWarn] = useState(false);

  const [birthWatch, issueWatch] = useWatch({
    control,
    name: ["person.birthDate", "person.identityDocument.issuedDate"] as Path<T>[],
  });

  useEffect(() => {
    if (!validatePassportIssueDate(birthWatch, issueWatch)) {
      setIssueDateWarn(true);
    } else {
      setIssueDateWarn(false);
    }
  }, [birthWatch, issueWatch]);

  return {
    issueDateWarn,
  };
};
